import { PropsWithChildren } from 'react';
import styled from '@emotion/styled';

export interface ChipProps {
  selected: boolean;
  defaultLineColor?: string;
  defaultBackgroundColor?: string;
  selectedLineColor?: string;
  selectedBackgroundColor?: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  className?: string;
}

const CustomChip = ({
  selected,
  defaultBackgroundColor,
  defaultLineColor,
  selectedLineColor,
  selectedBackgroundColor,
  onClick,
  className,
  children,
}: PropsWithChildren<ChipProps>) => {
  return (
    <ChipWrapper
      className={className}
      selected={selected}
      defaultLineColor={defaultLineColor}
      defaultBackgroundColor={defaultBackgroundColor}
      selectedLineColor={selectedLineColor}
      selectedBackgroundColor={selectedBackgroundColor}
      onClick={onClick}
    >
      {children}
    </ChipWrapper>
  );
};

const ChipWrapper = styled.div<{
  selected: boolean;
  defaultLineColor?: string;
  defaultBackgroundColor?: string;
  selectedLineColor?: string;
  selectedBackgroundColor?: string;
}>`
  outline: ${({ selected, selectedLineColor, defaultLineColor, theme }) => {
    if (selected) {
      return selectedLineColor === 'none'
        ? 'unset'
        : `2px solid ${selectedLineColor ?? theme.colors.blue.s500}`;
    }
    if (defaultLineColor === 'none') {
      return 'unset';
    }
    return `1px solid ${defaultLineColor ?? theme.colors.gray.s200}`;
  }};
  border-radius: 16px;
  padding: 6px 14px;
  background-color: ${({ selected, selectedBackgroundColor, defaultBackgroundColor, theme }) =>
    selected
      ? selectedBackgroundColor ?? theme.colors.blue.s50
      : defaultBackgroundColor ?? theme.colors.white};
  cursor: pointer;
`;

export default CustomChip;
